var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty3Little(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.443,
    height: 48.586,
    viewBox: "0 0 25.443 48.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M197.808,26.051S202.592,29.709,204,20.7,206.25-.4,212.44,2.415s-3.1,9-2.251,12.944,6.391,9.5,9-1.126c2.11-8.582-3.436-6.99-4.5-4.5-.422.985-2.251,4.784,5.065,18.853s-1.97,12.662-2.532,8.723-3.377-5.909-3.939-3.658S215.45,41.6,216.1,44.06c.7,2.673.844,6.753-3.939,5.909s-4.221-3.377-7.316-1.97",
    transform: "translate(-197.458 -1.749)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    strokeDasharray: "1.5 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty3Little);
export default __webpack_public_path__ + "static/media/empty-3-little.339f6c05170e80eb69558cb31ee1b93b.svg";
export { ForwardRef as ReactComponent };